import React, { Fragment, useState, useRef } from "react";
import { Menu } from "antd";
import { createFromIconfontCN } from "@ant-design/icons";
import { Link } from "react-router-dom";
import "./Sidebar.css";
import PerfectScrollbar from 'react-perfect-scrollbar'
// import imgSmall from './../assets/img/icon-sidebar-small.png'
import logo from './../assets/img/banner-dashboard.png'

const { SubMenu } = Menu;

const IconFont = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_1964787_1z33meo70x9.js",
});

function Sidebar(props) {
  const [openKeys, setOpenKeys] = useState("");
  const pathname = props.location.pathname.split("/");

  const handleOpenSub = (path) => {
    if (path !== openKeys) {
        setOpenKeys(path)
        sessionStorage.setItem('openKeys', path)
    } else {
        setOpenKeys('')
        sessionStorage.setItem('openKeys', '')
    }
  }
  const permissions = sessionStorage.getItem("permissions")
    ? JSON.parse(sessionStorage.getItem("permissions")).filter(
      (permission) => permission !== null
      )
    : [];
  
  const activePath = props.history.location.pathname;
  const shadowRef = useRef(null)

  // ** Scroll Menu
  const scrollMenu = container => {
    if (shadowRef && container.scrollTop > 0) {
      if (!shadowRef.current.classList.contains('d-block')) {
        shadowRef.current.classList.add('d-block')
      }
    } else {
      if (shadowRef.current.classList.contains('d-block')) {
        shadowRef.current.classList.remove('d-block')
      }
    }
  }

  return (
    <>
      <div className="main-menu menu-fixed menu-light menu-accordion menu-shadow" data-scroll-to-active="true">
        <div className="navbar-header">
            <ul className="nav navbar-nav flex-row">
              <li className="nav-item mr-auto">
                <div className="navbar-brand">
                  <img
                    src={logo}
                    alt="DEM Logo"
                    className="sidebar-logo"
                  />
                </div>
              </li>
              <li className="nav-item nav-toggle">
                <a className="nav-link modern-nav-toggle pr-0" data-toggle="collapse">
                  <i className="d-block d-xl-none text-primary toggle-icon font-medium-4" data-feather="x"></i>
                  <i className="d-none d-xl-block collapse-toggle-icon font-medium-4  text-primary" data-feather="disc" data-ticon="disc"></i>
                </a>
              </li>
          </ul>
        </div>
        <div className="shadow-bottom" ref={shadowRef}></div>
        <PerfectScrollbar
          className='main-menu-content bg-custom'
          options={{ wheelPropagation: false }}
          onScrollY={container => scrollMenu(container)}
        >
        {/* <div className="main-menu-content bg-custom"> */}
          <ul className="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
          {permissions &&
            permissions.length > 0 &&
            permissions.map((permission, index) => {
              return permission.children && permission.children.length > 0 ? (
                <>
                  <li className=" navigation-header" key={index}>
                    <span data-i18n="Apps &amp; Pages">{permission.name}</span>
                  </li>
                    {permission.children &&
                      permission.children.map((child, index) => {
                        return ( child && (
                            <li className={activePath === `/${child.url}` ? "nav-item active" : "nav-item"} data-class={child.url} key={index}>
                              <Link to={`/${child.url}`} className="d-flex align-items-center">
                                <i data-feather="mail"></i>
                                <span className="menu-title text-truncate">{child.name}</span>
                              </Link>
                            </li>
                          )
                        );
                      })
                    }
                </>
              ) : (
                <Menu.Item key={permission.url}>
                  <IconFont style={{ fontSize: 20 }} type={permission.icon} />
                    <span>{permission.name}</span>
                </Menu.Item>
              );
            })}

          </ul>

        {/* </div> */}
        </PerfectScrollbar>
      </div>
    </>
  );
}

export default Sidebar;
